import { placeWallTimeToInstant } from '../dates/index.js';
/** The stored instants of a wall schedule in `zone`; a DST gap moves forward, an overlap takes the earlier. */
export function calEventInstants(schedule, zone) {
    return {
        dateStart: placeWallTimeToInstant(schedule.startDate, schedule.startTime, zone),
        dateEnd: placeWallTimeToInstant(schedule.endDate, schedule.endTime, zone),
    };
}
//# sourceMappingURL=cal-event-instants.js.map